import { render, staticRenderFns } from "./BTablePassportTemplates.vue?vue&type=template&id=83f123bc&"
import script from "./BTablePassportTemplates.vue?vue&type=script&lang=js&"
export * from "./BTablePassportTemplates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports